import React from 'react';
import {createRoot} from 'react-dom/client';
import LocationsSelector from './LocationsSelector.jsx';
import DispositionsSelector from './DispositionsSelector.jsx';
import Select, { components } from 'react-select';
import { withTranslation } from 'react-i18next';
import TooltipSimple from '../myspace/common/tooltips/TooltipSimple.jsx';

import './PackageProductForm.scss';

class PackageProductFormComponent extends React.Component {

    constructor(props) {
        super(props);
        this.date_shift_options = [
            {value: '-1', label: this.props.trad.la_veille},
            {value: '', label: this.props.trad.le_jour_meme},
            {value: '1', label: this.props.trad.le_lendemain},
        ];

        let date_shift_selected = this.date_shift_options.filter((shift) => {
            return shift.value == (this.props.defaultProduct.date_shift ?? '')
        });
        
        this.state = {
            isLoaded: false,
            product: this.props.defaultProduct,
            pax: this.props.defaultProduct.pax,

            hour_start: this.props.defaultProduct.hour_start,
            hour_end: this.props.defaultProduct.hour_end,

            hour_start_displayed: this.props.defaultProduct.hour_start,
            hour_end_displayed: this.props.defaultProduct.hour_end,

            date_shift: date_shift_selected.length>0 ? date_shift_selected[0] : null,
            disposition: this.props.defaultProduct.meeting_rooms_type_slug,
            price: this.props.defaultProduct[this.props.priceFieldname],
            devise: this.props.devise,
            locations: this.props.defaultProduct.locations_id.length>0 ? this.props.defaultProduct.locations_id.split(',') : [],
            description: this.props.defaultProduct.product_description,
            product_label: this.props.defaultProduct.product_label,
            
            locations_component_loaded: false,
            dispositions_component_loaded: false,

            qty_factor_parent: this.props.defaultProduct.qty_factor_parent,
            qty_factor_child: this.props.defaultProduct.qty_factor_child,
            initial_stock: this.props.defaultProduct.initial_stock,

            all_dispositions: [],
            all_locations: [],
            all_pax: {},

            qty_factor_class: (this.props.defaultProduct.qty_factor_parent == 1 && this.props.defaultProduct.qty_factor_child == 1) ? 'd-none' : ''
            
        };

        this.selectStyles = {
            menu: base => ({
                ...base,
                marginTop: 0,
                'z-index': 10
            })
        }
    }

    componentDidUpdate() {
        if(!this.state.dispositions_component_loaded && this.props.all_dispositions_loaded) {
            this.setState({
                all_dispositions: this.props.dispositions,
                dispositions_component_loaded: true
            }, () => this.handleChange());
        }

        if(!this.state.locations_component_loaded && this.props.all_locations_loaded) {
            this.setState({
                all_locations: this.props.locations,
                locations_component_loaded: true
            }, () => this.handleChange());
        }
    }

    handleChangePax = (event) => {   
        let product = {...this.state.product, pax: event.target.value};
        this.setState({
            pax: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    handleChangePrice = (event) => {   
        let product = {...this.state.product};
        product[this.props.priceFieldname] = event.target.value;
        let new_state = {};
        new_state['price'] = event.target.value;
        new_state['product'] = product;
        this.setState(new_state, () => this.handleChange());
    }

    handleChangeHourStart = (event) => {
        let new_state = {
            hour_start_displayed: event.target.value
        };
        if(event.target.value === '') {
            let product = {...this.state.product, hour_start: event.target.value};
            new_state.hour_start = event.target.value;
            new_state.product = product;
            this.setState(new_state, () => this.handleChange());
        } else {
            this.setState(new_state);
        }
        
    }

    handleBlurHourStart = (event) => {   
        let product = {...this.state.product, hour_start: event.target.value};
        this.setState({
            hour_start: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    handleChangeHourEnd = (event) => {   
        let new_state = {
            hour_end_displayed: event.target.value
        };
        if(event.target.value === '') {
            let product = {...this.state.product, hour_end: event.target.value};
            new_state.hour_end = event.target.value;
            new_state.product = product;
            this.setState(new_state, () => this.handleChange());
        } else {
            this.setState(new_state);
        }
    }

    handleBlurHourEnd = (event) => {   
        let product = {...this.state.product, hour_end: event.target.value};
        this.setState({
            hour_end: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    handleChangeDateShift = (date_shift) => {   
        let product = {...this.state.product, date_shift: date_shift.value};
        this.setState({
            date_shift: date_shift,
            product: product
        }, () => this.handleChange());
    }

    handleChangeLocations = (locations) => {
        let locations_id_tab = [];
        locations_id_tab = locations.map((loc) => loc.value);
        let product = {...this.state.product};
        if(locations_id_tab.length > 0) {
            product.locations_id = locations_id_tab.join(',');
        } else {
            product.locations_id = '';
        }
        this.setState({
            locations: locations_id_tab,
            product: product
        }, () => this.handleChange());
    }
    
    handleChangeDisposition = (disposition) => {
        let product = {...this.state.product, meeting_rooms_type_slug: disposition.value};
        this.setState({
            disposition: disposition,
            product: product
        }, () => this.handleChange());
    }

    handleChangeDescription = (event) => {   
        let product = {...this.state.product, product_description: event.target.value };
        this.setState({
            description: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    handleChangeProductLabel = (event) => {   
        let product = {...this.state.product, product_label: event.target.value };
        this.setState({
            product_label: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    handleChange = () => {
        if (this.props.onChange) {
            this.props.onChange({
                product: this.state.product,
                index: this.props.index,
                loaded: this.state.dispositions_component_loaded && this.state.locations_component_loaded
            });
        }
    }

    handleLoadLocations = () => {
        this.setState({
            locations_component_loaded: true
        }, () => this.handleChange());
    }

    handleLoadDispositions = () => {
        
        this.setState({
            dispositions_component_loaded: true
        }, () => this.handleChange());
    }

    handleChangeQtyFactorParent = (event) => {   
        let product = {...this.state.product, qty_factor_parent: event.target.value};
        this.setState({
            qty_factor_parent: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    handleChangeQtyFactorChild = (event) => {   
        let product = {...this.state.product, qty_factor_child: event.target.value};
        this.setState({
            qty_factor_child: event.target.value,
            product: product
        }, () => this.handleChange());
    }

    setQtyFactorClass = () => {
        const new_class = this.state.qty_factor_class == 'd-none' ? '' : 'd-none';
        this.setState({
            qty_factor_class: new_class
        });
    }

    
    render() {
        const { t: gctrad } = this.props;
        const date_shift_elt = (
            <Select 
                options={this.date_shift_options}  
                onChange={this.handleChangeDateShift} 
                value={this.state.date_shift}
                classNamePrefix="react-select"
                styles={this.selectStyles}
            >
            </Select>
        );
        return (
            <div className='border mb-3'>
                <div className='row m-0 p-0 bg-light'>
                    <div className="col p-1 d-flex align-items-center  bg-light text-gc-dark-blue font-weight-bold">
                        <input type="text" className="form-control bg-white border-0 text-gc-green font-weight-bold" value={this.state.product_label} onChange={this.handleChangeProductLabel} />
                    </div>

                    {this.props.has_functions_sheets == 1 && (
                        <div className="col-2 p-1 text-gc-green">
                            {date_shift_elt}
                        </div>
                    )}

                    <div className="col-2 p-1">
                        <div className="input-group">
                            <input type="text" 
                                className="form-control bg-white border-0 text-gc-green text-right font-weight-bold" 
                                value={this.state.price} 
                                onChange={this.handleChangePrice}  
                            />
                            <div className="input-group-append">
                                <span className="font-weight-bold input-group-text border-0 text-gc-dark-blue">{this.state.devise}</span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-1 align-items-center bg-gc-mdlt-blue">

                        <TooltipSimple
                            title={gctrad('Différencier les quantités')}
                        >
                            <button className='btn font-weight-bold text-white mx-1' onClick={this.setQtyFactorClass}>
                                <i className="fa-light fa-square-sliders-vertical h4 m-0"></i>
                            </button>
                        </TooltipSimple>

                        <div className={"input-group "+this.state.qty_factor_class}>
                            <input type="text" className="form-control bg-white border-0 text-gc-green font-weight-bold input-qty-factor mx-1" value={this.state.qty_factor_parent} onChange={this.handleChangeQtyFactorParent} />
                            <div className="input-group-append">
                                <span className="input-group-text border-0 text-gc-dark-blue">{gctrad('package(s)')}</span>
                            </div>
                        </div>

                        <i className={"fa-solid fa-equals text-gc-dark-blue mx-2 "+this.state.qty_factor_class}></i>

                        <div className={"input-group "+this.state.qty_factor_class}>
                            <input type="text" className="form-control bg-white border-0 text-gc-green font-weight-bold input-qty-factor mx-1" value={this.state.qty_factor_child} onChange={this.handleChangeQtyFactorChild} />

                            <div className="input-group-append">
                                <span className="input-group-text border-0 text-gc-dark-blue">{gctrad('produit(s)')}</span>
                            </div>
                        </div>
                        
                    </div>
                    

                </div>

                {this.props.has_functions_sheets == 0 && 'rooms_types' != this.state.product.type && <div className="row m-0 p-1 pb-0 product-package-row">

                    <div className="col-6 col-xl-3 p-1">
                        <input type="time" 
                            className={"form-control mr-1 bg-white border-0 font-weight-bold " +(this.state.hour_start_displayed == '' ? 'text-gc-orange' : 'text-gc-green')}
                            value={this.state.hour_start_displayed} 
                            onChange={this.handleChangeHourStart} 
                            onBlur={this.handleBlurHourStart} 
                        />
                    </div>

                    <div className="col-6 col-xl-3 p-1">
                        <input type="time" 
                            className={"form-control ml-1 bg-white border-0 font-weight-bold " +(this.state.hour_end_displayed == '' ? 'text-gc-orange' : 'text-gc-green')}
                            value={this.state.hour_end_displayed} 
                            onChange={this.handleChangeHourEnd} 
                            onBlur={this.handleBlurHourEnd} 
                        />
                    </div>

                    <div className="col-12 col-xl-6 p-1">
                        <LocationsSelector 
                            hotels_id={this.props.hotels_id} 
                            onChange={this.handleChangeLocations}
                            onLoad={this.handleLoadLocations}
                            multiple={true}
                            displayPax={true}
                            name="locations_ids[]"
                            parentLoaded={this.state.locations_component_loaded}
                            defaultValue={this.state.locations}
                            ajax_load={false}
                            locations_loaded={this.state.all_locations}
                            classNamePrefix="react-select"
                            >
                        </LocationsSelector>
                    </div>

                    {'rooms_types' != this.state.product.type && (
                        <div className="col-12 col-xl-6 p-1 text-gc-green">
                            {this.props.global == 0 && date_shift_elt}
                        </div>
                    )}


                    {'meeting-rooms' == this.state.product.type && (
                        <div className="col-6 col-xl-3 p-1">
                            <DispositionsSelector 
                                onChange={this.handleChangeDisposition}
                                onLoad={this.handleLoadDispositions}
                                allPax={this.state.all_pax}
                                refreshPax={this.state.refreshPax}
                                parentLoaded={this.state.dispositions_component_loaded}
                                defaultValue={this.props.defaultProduct.meeting_rooms_type_slug}
                                ajax_load={false}
                                dispositions_loaded={this.state.all_dispositions}
                                classNamePrefix="react-select"
                                >
                            </DispositionsSelector>
                        </div>
                    )}

                    {'meeting-rooms' == this.state.product.type && (
                        <div className="col-6 col-xl-3 p-1">
                            <div className="input-group min-w-100px">
                                <input type="text" 
                                    className={"form-control input_pax font-weight-bold text-right border-0 " +(this.state.pax > 0 ? 'text-gc-green' : 'text-gc-orange')} 
                                    name="pax" 
                                    value={this.state.pax} 
                                    onChange={this.handleChangePax}
                                />
                                <div className="input-group-append">
                                    <span className={"font-weight-bold input-group-text border-0 " +(this.state.pax > 0 ? 'text-gc-green' : 'text-gc-orange')}>{this.props.trad.label_pax}</span>
                                </div>
                            </div>
                        </div>
                    )}

			    </div>}

                <div className='row m-0 px-2 pb-2 product-package-row'>
                    <div className="col m-0 p-0">
                        <textarea 
                            className='form-control border-0' 
                            rows="2" 
                            value={this.state.description} 
                            onChange={this.handleChangeDescription}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        )
    }

}

const PackageProductForm = withTranslation()(PackageProductFormComponent);
export default PackageProductForm;

PackageProductForm.defaultProps = {
    trad: TRAD.PackageProductForm ?? {}
};
